module.exports = __webpack_public_path__ + "static/media/title_8.55a7f190.svg";